import {Component} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {MessageAdminRole} from "@domain/admin/bibliotheque/notification/message-admin-role";
import {TypeProfil} from "@domain/user/user";
import {TranslateService} from "@ngx-translate/core";

/**
 * Composant d'affichage des items de la liste des rôles à ajouter
 *
 * @author Lionel Gimenez
 * @date 31/03/2026
 */
@Component({
    host: {'data-test-id': 'role-select-item'},
    selector: 'role-select-item',
    templateUrl: './role-select-item.component.html'
})
export class RoleSelectItemComponent extends ListViewItem<MessageAdminRole> {
    readonly TypeProfil = TypeProfil;

    /**
     * Constructeur
     *
     * @param translateService le moteur de traduction
     */
    constructor(
        public translateService: TranslateService
    ) {
        super();
    }
}
